import React, {
    RefObject, memo
} from "react";
import getConfig from "next/config";

import styles from "./SideBySideJDP.module.scss";

/**
 * Generates a URL for a side-by-side job description Iframe.
 */
export const generateSideBySideUrl = (job: string) => {
    const { publicRuntimeConfig: { museWebHost } } = getConfig();
    // Add additional parameters to help the target site identify this as a legitimate iframe
    return job ? `${museWebHost}/jobs/${job}?framed` : "";
};

interface IframeProps {
    isOpen: boolean;
    iframeURL: string;
}

/**
 * The actual Iframe wrapped in a memo so we always rerender with new URLs.
 * Starting iframes with about:blank and then updating their URL is a common technique to ensure a blank state before
 * loading a new page. This approach helps to prevent issues with caching, browser history, and ensures a clean reset
 * of the iframe's content before loading a new URL. Has the added bonus of starting life as a friendly frame.
 */
export const Iframe = memo(({ isOpen, iframeURL }: IframeProps) => (
    <iframe
        className={styles.frame}
        title="JDP"
        loading="lazy"
        src={isOpen && iframeURL ? iframeURL : "about:blank"}
    />
));
Iframe.displayName = "Iframe";

interface SideBySideJDPProps {
    iframeRef: RefObject<HTMLDivElement>;
    isOpen: boolean;
    selectedJob: string | null;
}

export const SideBySideJDP: React.FC<SideBySideJDPProps> = ({
    iframeRef,
    isOpen,
    selectedJob,
}) => {
    // about:blank will set most browsers iframe to friendly
    const iframeURL = selectedJob ? generateSideBySideUrl(selectedJob) : "about:blank";

    return (
        <div ref={iframeRef} className={`${styles.frameWrapper} ${isOpen ? styles.frameWrapper_open : ""}`}>
            <Iframe isOpen={isOpen} iframeURL={iframeURL} />
        </div>

    );
};
SideBySideJDP.displayName = "SideBySideJDP";
